import { Injectable } from '@angular/core';
import { AuthenticationResult, EventMessage } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

import { AuthenticationStage } from '@core/messages';
import { AuthEventContextHelper, securityLog } from '../helpers';
import { AccountContextService, AuthAccountService, AuthRequestBuilderService, TenantClaimResolverService } from '../services';

export interface AuthSuccessCommandResult {
    authenticationResult: AuthenticationResult;
    authority: string;
    tenant?: string;
    stage: AuthenticationStage;
}

@Injectable({
    providedIn: 'root'
})
export class HandleAuthSuccessCommand {
    constructor(
        private msalService: MsalService,
        private accountService: AuthAccountService,
        private accountContext: AccountContextService,
        private authRequestBuilder: AuthRequestBuilderService,
        private authEventContext: AuthEventContextHelper,
        private tenantClaimResolver: TenantClaimResolverService,
    ) { }

    public execute(message: EventMessage): AuthSuccessCommandResult | undefined {
        securityLog.debug('HandleAuthSuccessCommand: execute', { eventType: message.eventType });

        const authority = this.authEventContext.resolveAuthorityFromEventMessage(message);
        if (authority.indexOf('passwordreset') > -1) {
            this.msalService.logout();
            return undefined;
        }

        const authenticationResult = message.payload as AuthenticationResult;

        this.accountService.setActiveAccount(authenticationResult.account);
        this.accountContext.updateAuthContextFromResult(authenticationResult, authority);
        this.authRequestBuilder.clearForcePromptLogin();
        this.accountContext.persistPinnedAccountInformationFromResult(authenticationResult, authority);

        return {
            authenticationResult,
            authority,
            tenant: this.tenantClaimResolver.resolveTenantFromAuthResult(authenticationResult),
            stage: this.authEventContext.resolveLoggingInStageFromAuthResult(message, authenticationResult),
        };
    }
}